import api from "../api/api";

const parseMoneyConfig = (value, envName) => {
  const parsed = Number(value);

  if (!Number.isFinite(parsed) || parsed < 0) {
    throw new Error(
      `Invalid ${envName} value: '${value}'. Please set a non-negative number in frontend .env.`,
    );
  }

  return parsed;
};

export const FREE_SHIPPING_THRESHOLD = parseMoneyConfig(
  process.env.REACT_APP_FREE_SHIPPING_THRESHOLD,
  "REACT_APP_FREE_SHIPPING_THRESHOLD",
);

export const STANDARD_SHIPPING_RATE = parseMoneyConfig(
  process.env.REACT_APP_STANDARD_SHIPPING_RATE,
  "REACT_APP_STANDARD_SHIPPING_RATE",
);

export const SHIPPING_CONFIG_DEFAULTS = {
  freeShippingThreshold: FREE_SHIPPING_THRESHOLD,
  standardShippingRate: STANDARD_SHIPPING_RATE,
};

export const fetchShippingConfig = async () => {
  const response = await api.get("/config/shipping");

  return {
    freeShippingThreshold: parseMoneyConfig(
      response.data?.free_shipping_threshold,
      "free_shipping_threshold",
    ),
    standardShippingRate: parseMoneyConfig(
      response.data?.standard_shipping_rate,
      "standard_shipping_rate",
    ),
  };
};
